import {
  Button,
  Drawer,
  Icon,
  Panel,
  SectionHeader
} from '@deque/cauldron-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Separator from '~/modules/common/components/Separator';
import { useProducts } from '~/modules/common/contexts/products';
import { type EnterpriseMembers } from '~/modules/common/utils/billing-client/client-v2';
import styles from './ViewPendingMemberDetails.css';

interface ViewPendingMemberDetailsProps {
  member: EnterpriseMembers.PendingMember;
  onViewDetailsClose: () => void;
  onResendInvitation: (member: EnterpriseMembers.PendingMember) => void;
  onRemoveClick: (member: EnterpriseMembers.PendingMember) => void;
}

function ViewPendingMemberDetails({
  member,
  onViewDetailsClose,
  onResendInvitation,
  onRemoveClick
}: ViewPendingMemberDetailsProps) {
  const { t } = useTranslation();
  const { getProductBySlug } = useProducts();

  return (
    <>
      <Drawer
        open={!!member}
        onClose={onViewDetailsClose}
        position="right"
        className={styles.drawer}
      >
        <Panel className={styles.panel}>
          <Button variant="secondary" onClick={onViewDetailsClose}>
            <Icon type="close" />
            {t('Close')}
          </Button>
          <Separator />
          <SectionHeader
            heading={member.email}
            description={t('Invite pending')}
          />
          <Separator />
          <SectionHeader
            heading={<h3>{t('Product access and activity')}</h3>}
          />
          <div className={styles.productAccessContainer}>
            {member.product_access.map(access => (
              <Panel key={access.product_slug}>
                <h4>{getProductBySlug(access.product_slug)?.name}</h4>
                <p>{t('Invite pending')}</p>
              </Panel>
            ))}
            <Panel>
              <h4>
                {t('Axe Account')} {member.is_admin && t('(admin)')}
              </h4>
              <p>{t('Invite pending')}</p>
            </Panel>
          </div>
          <Separator />
          <SectionHeader heading={<h3>{t('Actions')}</h3>} />
          <div className={styles.actionsContainer}>
            <Button
              variant="secondary"
              onClick={() => onResendInvitation(member)}
            >
              {t('Resend invite')}
            </Button>
            <Button
              variant="danger-secondary"
              onClick={() => onRemoveClick(member)}
            >
              {t('Remove user')}
            </Button>
          </div>
        </Panel>
      </Drawer>
    </>
  );
}

export default ViewPendingMemberDetails;
